
const collectionLayoutSwitch = function() {
  const cusListViews = document.querySelectorAll(".cus_list_view");
  const cusGridViews = document.querySelectorAll(".cus_grid_view");
  const productGrid = document.querySelector(".product-grid");

  // helper function for fadeOut
  function fadeOut(el, duration, callback) {
    el.style.transition = `opacity ${duration}ms`;
    el.style.opacity = 0;
    setTimeout(() => {
      el.style.display = "none";
      if (callback) callback.call(el);
    }, duration);
  }

  // helper function for fadeIn
  function fadeIn(el, duration) {
    el.style.display = "";
    el.style.transition = `opacity ${duration}ms`;
    el.style.opacity = 0;
    requestAnimationFrame(() => {
      el.style.opacity = 1;
    });
  }


  cusListViews?.forEach(cusListView => {
    cusListView.addEventListener("click", function () {
      cusListView.closest('.collection-list-grid-wrapper').querySelector('.cus_grid_view').classList.remove("active");
      cusListView.classList.add("active");

      fadeOut(productGrid, 200, function () {
        productGrid.classList.remove("grid-active");
        productGrid.classList.add("list-active");
        fadeIn(productGrid, 200);
      });
    });
  })
  

  cusGridViews?.forEach(cusGridView => {
    cusGridView.addEventListener("click", function () {
      cusGridView.closest('.collection-list-grid-wrapper').querySelector('.cus_list_view').classList.remove("active");
      cusGridView.classList.add("active");

      fadeOut(productGrid, 200, function () {
        productGrid.classList.remove("list-active");
        productGrid.classList.add("grid-active");
        fadeIn(productGrid, 200);
      });
    });
  })
}

document.addEventListener("DOMContentLoaded", function () {
  collectionLayoutSwitch();
});

